import { useNavigate, useLocation } from 'react-router-dom';
import { FolderKanban, Blocks, Sparkles } from 'lucide-react';
import { AppSidebar, SidebarSection, SidebarItem, AppVersionBadge } from '@aaas/shared';

export interface KmsSidebarProps {
  isOpen?: boolean;
  onClose?: () => void;
}

export function KmsSidebar({ isOpen = true, onClose }: KmsSidebarProps) {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => {
    // Check if current path matches exactly
    if (location.pathname === path) return true;

    // For /kms/spaces route, also consider it active for related paths
    if (path === '/kms/spaces' && location.pathname.startsWith('/kms/spaces')) {
      return true;
    }

    // For /kms/widgets route, also consider it active for related paths
    if (path === '/kms/widgets' && location.pathname.startsWith('/kms/widgets')) {
      return true;
    }

    // For /kms/integrations route, also consider it active for detail pages
    if (path === '/kms/integrations' && location.pathname.startsWith('/kms/integrations')) {
      return true;
    }

    return false;
  };

  const handleNavigation = (path: string) => {
    navigate(path);
    onClose?.();
  };

  return (
    <AppSidebar isOpen={isOpen} onClose={onClose}>
      {/* Default Section */}
      <SidebarSection title="Default">
        <SidebarItem
          icon={<FolderKanban className="h-5 w-5" />}
          label="Space"
          isActive={isActive('/kms/spaces')}
          onClick={() => handleNavigation('/kms/spaces')}
        />
        <SidebarItem
          icon={<Sparkles className="h-5 w-5" />}
          label="Widgets"
          isActive={isActive('/kms/widgets')}
          onClick={() => handleNavigation('/kms/widgets')}
        />
      </SidebarSection>

      {/* Settings Section */}
      <SidebarSection title="Settings">
        <SidebarItem
          icon={<Blocks className="h-5 w-5" />}
          label="Integrations"
          isActive={isActive('/kms/integrations')}
          onClick={() => handleNavigation('/kms/integrations')}
        />
      </SidebarSection>

      <div className="px-4 pt-4 mt-2 border-t border-gray-100">
        <AppVersionBadge slug="kms" />
      </div>
    </AppSidebar>
  );
}
